import React from 'react'
import { ClientLogStream, LogConfig, LogSeverity, SeverityTranslation } from 'api'
import { translate } from 'locale/Locale'
import { Translation } from 'locale'
import { LogLevelComponent } from './components/LogLevelComponent'
import { ClientLogStreamScreenContent, ItalicMessage } from './ClientLogStreamScreen.styled'

interface ClientLogStreamScreenProps {
  logConfig: LogConfig
  onChange: (logStream: ClientLogStream, logLevel: LogSeverity | undefined) => void
}

export const ClientLogStreamScreen: React.FC<ClientLogStreamScreenProps> = ({ logConfig, onChange }) => {
  const logLevelToSeverityTranslation = (logLevel?: LogSeverity): SeverityTranslation => {
    return logLevel
      ? {
          [LogSeverity.INFO]: SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_INFO,
          [LogSeverity.ERROR]: SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_ERROR,
          [LogSeverity.WARN]: SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_WARN
        }[logLevel]
      : SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_NONE
  }

  const mapSeverityTranslationToLogSeverity = (translation: SeverityTranslation): LogSeverity | undefined => {
    return {
      [SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_WARN]: LogSeverity.WARN,
      [SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_ERROR]: LogSeverity.ERROR,
      [SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_INFO]: LogSeverity.INFO,
      [SeverityTranslation.TC_CLIENT_LOGSTREAM_SEVERITY_NONE]: undefined
    }[translation]
  }
  return (
    <ClientLogStreamScreenContent>
      <ItalicMessage>{translate(Translation.SC_CLIENT_LOGSTREAM_GLOBAL_WARNING_MESSAGE)}</ItalicMessage>
      {Object.values(ClientLogStream).map(logStream => (
        <LogLevelComponent
          dataTestId={logStream}
          label={logStreamToString(logStream)}
          value={logLevelToSeverityTranslation(logConfig[logStream])}
          key={logStream}
          onChange={logLevel => onChange(logStream, mapSeverityTranslationToLogSeverity(logLevel))}
        />
      ))}
    </ClientLogStreamScreenContent>
  )
}

const logStreamToString = (logStream: ClientLogStream) =>
  ({
    [ClientLogStream.ENTITY_UPDATES]: translate(Translation.TC_CLIENT_LOGSTREAM_LABEL_ENTITYUPDATES),
    [ClientLogStream.GLOBAL]: translate(Translation.TC_CLIENT_LOGSTREAM_LABEL_GLOBAL)
  }[logStream])
